import React, { useEffect, useState } from "react";

import "./UiMap.scss";

const UiMapAddress = (props) => {
  const json =  {"type":"FeatureCollection","metadata":{"name":"mate","creator":"Yandex Map Constructor"},"features":[{"type":"Feature","id":0,"geometry":{"type":"Polygon","coordinates":[[[37.405291107925656,55.69751254027933],[37.4331798575516,55.662407917119886],[37.45969531616205,55.63892475800462],[37.49334094604485,55.60959111405624],[37.51325366577141,55.59442999879288],[37.59771106323236,55.57459504460255],[37.65195605834954,55.571871814267034],[37.687661624755805,55.575762085252094],[37.73023364624014,55.592680260636655],[37.7837919958495,55.617946648668976],[37.834113536662365,55.65019786505358],[37.83995002347877,55.658738799866235],[37.831710277385035,55.68745366846508],[37.829650340861576,55.698894912181686],[37.838576732463146,55.71382164733274],[37.843039928263934,55.77753503296386],[37.83754676420142,55.82240082696482],[37.7891382559006,55.850415591228476],[37.726310191935646,55.88265576176632],[37.70159095365438,55.894232495214716],[37.646659313029396,55.89654742576664],[37.59447425443565,55.908505690790356],[37.57318824369345,55.91159109370418],[37.480491100138764,55.88574322976519],[37.445472179240284,55.88188385620098],[37.40976661283404,55.870110386675584],[37.39740699369341,55.85852642708045],[37.391913829630916,55.847904749659435],[37.39363044340046,55.82568636533217],[37.384704051798884,55.8011347240865],[37.370971141642634,55.787595673353366],[37.36939648373389,55.74692507509003],[37.37694958431984,55.7312361330751],[37.38827923519874,55.709726183329856],[37.405291107925656,55.69751254027933]]]},"properties":{"fill":"#ed4543","fill-opacity":0,"stroke":"#ed4543","stroke-width":"2","stroke-opacity":0.5}}]};

  const [deliveryZones, setDeliveryZones] = useState([]);
  const [deliveryPoint, setDeliveryPoint] = useState(null);
  const [mainMap, stMainMap] = useState(null);

  useEffect(() => {
    window.ymaps.ready(() => {
    
     
      if(document.getElementById("suggest-input")){
        var suggestView = new window.ymaps.SuggestView("suggest-input", {
          provider: {
            suggest: function (request, options) {
              return window.ymaps.suggest("Москва , " + request);
            },
          },
        });

        suggestView.events.add("select", (e) => {
          var addr = e.originalEvent.item.value;
          props.onChangeAddress(addr);
        });

        document.getElementById("suggest-input").onblur = () => {
          //console.log("document.getElementById ", document.getElementById("suggest").value );
        };
  
      }
      

    

 
    });
  }, []);

 
  return null;
};
export default UiMapAddress;
